import Apollo from '@/store/interfaces/Apollo'
import gql from 'graphql-tag'
import { storage } from '@/utils/storage'

import { strates } from './parts/strates'
import { globalSet } from './parts/globalSet'

const apollo = new Apollo(process.env.VUE_APP_CRAFT_API, false)
apollo.setToken('Bearer ' + process.env.VUE_APP_CRAFT_TOKEN)
const graphqlClient = apollo.client

const site = process.env.VUE_APP_CRAFT_WEBSITE

class APICraft {

  getGlobal () {
    const args = arguments

    const request = new Promise((resolve, reject) => {
      graphqlClient.query({
        query: gql`
          query fetchGlobal {
            globalSet (site: "${site}") {
              ${globalSet}
            }
            entry(site: "${site}", type: "brightHomepage") {
              ... on brightHomepage_brightHomepage_Entry {
                id
                titre
                description
                brightLogos {
                  id
                  url
                }
                brightScreensVideo {
                  id
                  url
                }
                video {
                  id
                  url
                }
              }
            }
            categories(site: "${site}", group: "brigthProjectType") {
              id
              slug
              title
              groupHandle
              ... on brigthProjectType_Category {
                id
                image {
                  id
                  url
                }
              }
            }
          }
        `
      })
      .then(res => {
        
        const result = res.data

        resolve(result)
        storage.setItem( `fetchGlobal_${JSON.stringify(args)}`, result)
      })
      .catch(err => {
        console.error('Error catching global params ', err)
      })
    })
    const cache = storage.getItem( `fetchGlobal_${JSON.stringify(args)}`)

    return {
      request,
      cache
    }
  }

  getEntry (slug) {
    const args = arguments

    const request = new Promise((resolve, reject) => {
      graphqlClient.query({
        query: gql`
          query fetchEntry ($slug: [String]) {
            entry(site: "${site}", section: "brightCaseStudy", slug: $slug) {
              ... on brightCaseStudy_brightCaseStudy_Entry {
                id
                slug
                title
                description
                brightYear
                brightPlateform
                image {
                  id
                  url
                }
                brightTags {
                  title
                }
                popinMarketing: brightPopinMarketing {
                  ... on brightMarketingPopin_brightMarketingPopin_Entry {
                    id
                    slug
                    title
                    text: brightMarketingText
                    cta: brightMarketingCTA {
                      label: col1
                      url: col2
                    }
                    image: brightMarketingImage {
                      url
                      id
                    }
                  }
                }
                ${strates}
              }
            }
          }
        `,
        variables: { slug }
      })
      .then(res => {

        const result = res.data.entry

        resolve(result)
        storage.setItem( `getEntry_${JSON.stringify(args)}`, result)
      })
      .catch(err => {
        console.error('Error catching entry params ', err)
      })
    })
    const cache = storage.getItem( `getEntry_${JSON.stringify(args)}`)

    return {
      request,
      cache
    }
  }

  getEntries (ids) {
    const args = arguments

    const request = new Promise((resolve, reject) => {
      graphqlClient.query({
        query: gql`
          query fetchEntries ($id: [QueryArgument]) {
            entries (site: "${site}") {
              id
            }
          }
        `,
        variables: { id: ids }
      })
      .then(res => {

        const result = res.data.entries

        resolve(result)
        storage.setItem( `fetchEntries_${JSON.stringify(args)}`, result)
      })
      .catch(err => {
        console.error('Error catching entries params ', err)
      })
    })
    const cache = storage.getItem( `fetchEntries_${JSON.stringify(args)}`)

    return {
      request,
      cache
    }
  }

  getPage (slug) {
    const args = arguments

    const request = new Promise((resolve, reject) => {
      graphqlClient.query({
        query: gql`
          query fetchPage ($slug: [String]) {
            entry(site: "${site}", section: "brightPages", slug: $slug) {
              ... on brightPages_brightPages_Entry {
                id
                slug
                title
                ${strates}
              }
            }
          }
        `,
        variables: { slug }
      })
      .then(res => {

        const result = res.data.entry

        if (result) {
          resolve(result)
          storage.setItem( `fetchPage_${JSON.stringify(args)}`, result)
        }
        else {
          reject('page not found')
        }

      })
      .catch(err => {
        console.error('Error catching page params ', err)
      })
    })
    const cache = storage.getItem( `fetchPage_${JSON.stringify(args)}`)

    return {
      request,
      cache
    }
  }

  getEndPage (slug) {
    const args = arguments

    const request = new Promise((resolve, reject) => {
      graphqlClient.query({
        query: gql`
          query fetchEndPage {
            entry(site: "${site}", section: "brightEndPage") {
              ... on brightEndPage_brightEndPage_Entry {
                slug
                titre
                sousTitre
                brightPages {
                  ... on brightPages_link_BlockType {
                    id
                    label
                    image {
                      id
                    }
                    href
                  }
                }
                ${strates}
              }
            }
          }
        `,
        variables: { slug }
      })
      .then(res => {

        const result = res.data.entry

        if (result) {
          resolve(result)
          storage.setItem( `fetchEndPage_${JSON.stringify(args)}`, result)
        }
        else {
          reject('page not found')
        }

      })
      .catch(err => {
        console.error('Error catching page params ', err)
      })
    })
    const cache = storage.getItem( `fetchEndPage_${JSON.stringify(args)}`)

    return {
      request,
      cache
    }
  }

  getProjects (categories = []) {
    const args = arguments

    const request = new Promise((resolve, reject) => {
      graphqlClient.query({
        query: gql`
          query fetchProjects ($categories: [QueryArgument]) {
            entries(site: "${site}", section: "brightCaseStudy", brightType: $categories) {
              ... on brightCaseStudy_brightCaseStudy_Entry {
                id
                slug
                title
                description
                brightYear
                brightPlateform
                brightDescriptionPreview
                brightPreview {
                  id
                  url
                }
                brightTags {
                  title
                }
                brightType {
                  id
                  slug
                }
              }
            }
          }
        `,
        variables: { categories }
      })
      .then(res => {

        const result = res.data.entries

        resolve(result)
        storage.setItem( `getPageProjects_${JSON.stringify(args)}`, result)
      })
      .catch(err => {
        console.error('Error catching page params ', err)
      })
    })
    const cache = storage.getItem( `getPageProjects_${JSON.stringify(args)}`)

    return {
      request,
      cache
    }
  }

  getPromise (slug) {
    const args = arguments

    const request = new Promise((resolve, reject) => {
      graphqlClient.query({
        query: gql`
          query fetchPromise ($slug: [String]) {
            entry(site: "${site}", section: "brightPromise", slug: $slug) {
              ... on brightPromise_brightPromise_Entry {
                id
                title
                promiseTitle
                slug
                color
                brightPromiseVideos {
                  id
                  url
                }
                brightCaseStudy {
                  id
                  ... on brightCaseStudy_brightCaseStudy_Entry {
                    id
                    title
                    slug
                    brightYear
                    brightClient
                    brightPlateform
                    description
                    image {
                      id
                      url
                    }
                  }
                }
              }
            }
          }
        `,
        variables: { slug }
      })
      .then(res => {
        const result = res.data.entry

        resolve(result)
        storage.setItem( `getPromise_${JSON.stringify(args)}`, result)
      })
      .catch(err => {
        console.error('Error catching promise params ', err)
      })
    })
    const cache = storage.getItem( `getPromise_${JSON.stringify(args)}`)

    return {
      request,
      cache
    }
  }

  getShowreel () {
    const args = arguments

    const request = new Promise((resolve, reject) => {
      graphqlClient.query({
        query: gql`
          query fetchShowreel {
            entry(site: "${site}", section: "brightShowreel") {
              ... on brightShowreel_brightShowreel_Entry {
                id
                image {
                  id
                  url
                }
                video {
                  id
                  url
                }
              }
            }
          }
        `
      })
      .then(res => {

        const result = res.data.entry

        resolve(result)
        storage.setItem( `getEntry_${JSON.stringify(args)}`, result)
      })
      .catch(err => {
        console.error('Error catching global params ', err)
      })
    })
    const cache = storage.getItem( `getEntry_${JSON.stringify(args)}`)

    return {
      request,
      cache
    }
  }

  imgSize ({id, width, height, quality = 100, format}) {
    const args = arguments

    const request = new Promise((resolve, reject) => {
      let query = {}

      if (width && height) {
        query = {
          query: gql`
            query fetchImg ($id: [QueryArgument], $width: Int, $height: Int) {
              asset(id: $id) {
                ... on default_Asset {
                  url(
                    width: $width, 
                    immediately: true, 
                    height: $height, 
                    quality: ${quality}, 
                    ${format ? `format: "${format}"` : ''}
                  )
                }
              }
            }
          `,
          variables: { id, width, height }
        }
      }
      else if (width && !height) {
        query = {
          query: gql`
            query fetchImg ($id: [QueryArgument], $width: Int) {
              asset(id: $id) {
                ... on default_Asset {
                  url(width: $width, immediately: true, quality: ${quality}, ${format ? `format: "${format}"` : ''})
                }
              }
            }
          `,
          variables: { id, width }
        }
      }
      else if (!width && height) {
        query = {
          query: gql`
            query fetchImg ($id: [QueryArgument], $height: Int) {
              asset(id: $id) {
                ... on default_Asset {
                  url(height: $height, immediately: true, quality: ${quality}, ${format ? `format: "${format}"` : ''})
                }
              }
            }
          `,
          variables: { id, height }
        }
      }
      else {
        query = {
          query: gql`
            query fetchImg ($id: [QueryArgument])  {
              asset(id: $id) {
                ... on default_Asset {
                  url(immediately: true, quality: ${quality}, ${format ? `format: "${format}"` : ''})
                }
              }
            }
          `,
          variables: { id }
        }
      }

      graphqlClient.query(query)
        .then(res => {
          resolve(res.data.asset.url)

          const result = res.data.asset.url

          resolve(result)
          storage.setItem( `fetchImg_${JSON.stringify(args)}`, result)
        })
        .catch(err => {
          console.error('Error catching global params ', err)
        })
    })

    const cache = storage.getItem(`fetchImg_${JSON.stringify(args)}`)

    return {
      request,
      cache
    }
  }
}

export const api = new APICraft()